module.exports = __webpack_public_path__ + "onboarding-infrastructure.65f18784fa6ca59406ec8847569289c7.hashedasset.svg";